// extracted by mini-css-extract-plugin
module.exports = {"component":"search-widget-modal_component__tYChJ themeLight","curtain":"search-widget-modal_curtain__6hxQV"};